require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-hannah-bennett.json") })
        }
      }, "path---authors-hannah-bennett");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-hannah-bennett!./.cache/json/authors-hannah-bennett.json
// module id = 1284
// module chunks = 231608221292675